export const SIGNUP_URL = 'https://linktr.ee/ubcmuaythaiclub';
